/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';

// price level

export const storePriceLevelSearchData = (val) => {
  return {
    type: actionTypes.PRICE_LEVEL_SEARCH_INPUT_DATA,
    payload: val,
  };
};

export const storePriceLevelErrors = (val) => {
  return {
    type: actionTypes.PRICE_LEVEL_ERRORS,
    payload: val,
  };
};

// REBATE PROGRAM

export const getRebatePrograms = (val) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: val })
    .then((response) => {
      let { data, status, message } = response.data;
      let list = [];
      if (status === STATUS_MSG && message === SUCCESS_MSG) {
        if (Array.isArray(data) && data.length > 0) {
          list = data.map((val) => ({
            ...val,
            id: val.rebateProgramCd,
            name: `${val.rebateProgramCd} | ${val.shortDescr}`,
          }));
          list = list.sort((key, val) =>
            key.name.toLowerCase().localeCompare(val.name.toLowerCase())
          );
        }
      }
      return list;
    })
    .catch(() => {
      return [];
    });
};

// MANUFACTURER GRID

export const dispatchManufactGrid = (data) => {
  return {
    type: actionTypes.PRICE_LEVEL_MANUFACTURER_GRID,
    payload: data?.mfgGridDetails,
  };
};

export const getManufacturerGrid = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MFG_GRID_DETAILS}`, val)
    .then((response) => {
      return dispatch(dispatchManufactGrid(response.data));
    })
    .catch((response) => {
      return dispatch(dispatchManufactGrid(response.data));
    });
};

// DRUG FAMILY GRID

export const dispatchDrugFamilyGrid = (data) => {
  return {
    type: actionTypes.PRICE_LEVEL_DRUG_FAMILY,
    payload: data?.rebatePriceLevelDrugFamiliesLinkedWithMfg,
  };
};

export const getDrugFamily = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DRUG_FAMILIES_LINKED_WITH_MFGRID}`, val)
    .then((response) => {
      return dispatch(dispatchDrugFamilyGrid(response.data));
    })
    .catch((response) => {
      return dispatch(dispatchDrugFamilyGrid(response.data));
    });
};

// REBATE PRICE LEVEL DETAILS

export const dispatchRebatePriceLevelDetails = (data) => {
  return {
    type: actionTypes.REBATE_PRICE_LEVEL_DETAILS_API,
    payload: data,
  };
};

export const getRebatePriceLevelDetailsApi = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REBATE_PRICE_LEVEL_DETAILS, val)
    .then((response) => {
      return dispatch(dispatchRebatePriceLevelDetails(response.data));
    })
    .catch(() => {
      return dispatch(dispatchRebatePriceLevelDetails([]));
    });
};

// GRIDS
export const dispatchGetPriceDetailsGrid1 = (data) => {
  return {
    type: actionTypes.PRICE_DETAILS_GRIDS,
    payload: data,
  };
};
export const getPriceDetailGrids = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PRICE_DETAILS_GRIDS, val)
    .then((response) => {
      return dispatch(dispatchGetPriceDetailsGrid1(response.data));
    })
    .catch(() => {
      return dispatch(dispatchGetPriceDetailsGrid1([]));
    });
};

// SAVE GRID TWO

export const dispatchSaveGridTwo = (data) => {
  return {
    type: actionTypes.SAVE_GRID_TWO,
    payload: data,
  };
};

export const saveGridTwo = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_REBATE_PRICE_LEVEL_DETAILS, val)
    .then((response) => {
      return dispatch(dispatchSaveGridTwo(response.data));
    })
    .catch((response) => {
      return dispatch(dispatchSaveGridTwo(response.data));
    });
};

export const storeUpdatedPage = (val) => {
  return {
    type: actionTypes.STORE_UPDATED_PAGE,
    payload: val,
  };
};

export const dispatchGetPlanTypeDesc = (data, val) => {
  return {
    type: actionTypes.GET_PLAN_TYPE_DESC,
    payload: data?.PLAN_TYPE_CD?.filter(
      (e) => e.codeValueID?.codeValue === val
    ),
  };
};

export const getPlanTypeDesc = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.NDC_REFERENCE_DATA, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchGetPlanTypeDesc(response.data, val));
    })
    .catch((response) => {
      return dispatch(dispatchGetPlanTypeDesc(response.data, val));
    });
};

// price details

export const storePriceDetailsInputData = (val) => {
  return {
    type: actionTypes.PRICE_DETAILS_INPUT_DATA,
    payload: val,
  };
};

export const storeBlurState = (val) => {
  return {
    type: actionTypes.STORE_BLUR_STATE,
    payload: val,
  };
};

export const storeOverlapState = (val = [{ startQtrOverlap: false }]) => {
  return {
    type: actionTypes.STORE_OVERLAP_STATE_ERR,
    payload: val,
  };
};

export const storePriceDetailErrors = (val) => {
  return {
    type: actionTypes.PRICE_DETAIL_ERRORS,
    payload: val,
  };
};

export const storeRebatePriceDetails = (val) => {
  return {
    type: actionTypes.STORE_REBATE_PRICE_DETAILS,
    payload: val,
  };
};

export const storePriceLevelListed = (data) => ({
  type: actionTypes.STORE_PRICE_LEVEL_ALL_LIST,
  payload: data,
});

// Update Maintain Price Details
export const updateMaintainPriceLevel = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.UPDATE_REBATE_PRICE_LEVEL,
      values
    );
    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
